import cn from 'classnames';
/* Class assignment */
export var inlinealertClass = function (className) {
    return cn(className, 
    /* inlineAlert (base) */
    'flex p-4 bg-gray-600 rounded-xl space-x-4');
};
